import { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const { data } = await axios.post("http://localhost:3001/login", {
        username,
        password,
      });
      localStorage.setItem("token", data.token);
      history.push("/dashboard");
    } catch (error) {
      console.log(error.response.data);
    }
  };

  return (
    <div className="p-8 min-h-screen flex flex-col">
      <p className="mt-8 text-3xl font-bold mb-10">Log in</p>
      <form onSubmit={handleSubmit} className="pb-2 h-full flex flex-col">
        <div className="flex flex-col">
          <label>
            <b>Username</b>
          </label>
          <input
            type="text"
            placeholder="Enter Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="pl-4 mb-3 h-10 w-full rounded-lg"
            required
          />

          <label>
            <b>Password</b>
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="pl-4 h-10 w-full rounded-lg"
            placeholder="Enter Password"
            required
          />

          <button
            type="submit"
            className="mt-8 mb-4 h-10 font-bold w-full rounded-lg border-black border-2"
          >
            Log In
          </button>
        </div>
        <div className="flex justify-center">
          <p className="mr-2">Don't have an account?</p>
          <Link to="/signup">
            <span className="font-bold underline">Register</span>
          </Link>
        </div>
      </form>
    </div>
  );
};

export default Login;
